const cardBodyStyle = {
  cardBody: {
    padding: "0.9375rem",
    flex: "1 1 auto",
  },
};

export default cardBodyStyle;
